<template>
  <v-layout align-start>
    <v-flex>
      <v-tabs v-model="activeTab" color="deep-purple">
        <v-tab>Pendientes</v-tab>
        <v-tab>Aprobadas</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- Pendientes -->
        <v-tab-item>
          <v-toolbar flat color="transparent" class="mt-2">
            <v-toolbar-title>Solicitudes de Cambio Pendientes</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="text-xs-center" v-model="searchPending" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
          </v-toolbar>
          <v-data-table :headers="pendingHeaders" :items="pendingRequests" :search="searchPending" class="elevation-1">
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>
            <template v-slot:item.opciones="{ item }">
              <v-icon small color="green" class="mr-2" @click="approveRequest(item._id)">check_circle</v-icon>
              <v-icon small color="red" @click="rejectRequest(item._id)">cancel</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-center grey--text">No hay solicitudes pendientes</div>
            </template>
          </v-data-table>
        </v-tab-item>

        <!-- Aprobadas -->
        <v-tab-item>
          <v-toolbar flat color="transparent" class="mt-2">
            <v-toolbar-title>Solicitudes Aprobadas</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="text-xs-center" v-model="searchApproved" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
          </v-toolbar>
          <v-data-table :headers="approvedHeaders" :items="approvedRequests" :search="searchApproved" class="elevation-1">
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-center grey--text">No hay solicitudes aprobadas</div>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      activeTab: 0,
      searchPending: "",
      searchApproved: "",
      pendingHeaders: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Afiliado", value: "affiliateName", sortable: true },
        { text: "Campo", value: "fieldName", sortable: true },
        { text: "Valor Actual", value: "currentValue", sortable: false },
        { text: "Valor Nuevo", value: "newValue", sortable: false },
        { text: "Fecha", value: "createdAt", sortable: true },
      ],
      approvedHeaders: [
        { text: "Afiliado", value: "affiliateName", sortable: true },
        { text: "Campo", value: "fieldName", sortable: true },
        { text: "Valor Actual", value: "currentValue", sortable: false },
        { text: "Valor Nuevo", value: "newValue", sortable: false },
        { text: "Fecha", value: "createdAt", sortable: true },
      ],
    };
  },
  created() {
    this.getPendingRequests();
    this.getApprovedRequests();
  },
  computed: {
    ...mapState("profileChangeNamespace", ["pendingRequests", "approvedRequests"]),
  },
  methods: {
    ...mapActions("profileChangeNamespace", ["getPendingRequests", "getApprovedRequests", "approveRequest", "rejectRequest"]),
    formatDate(dateString) {
      if (!dateString) return "—";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
    },
  },
};
</script>
